module.exports = __webpack_public_path__ + "img/fig16.f3c0e9bd.jpg";